import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dialog, Box } from '@material-ui/core';
import { asyncFetch } from '../../helperFunctions';
import { setSnackbar, signedTechnicians } from '../redux';
import DigitalSignatureInput from './DigitalSignatureInput';
import InstructionsList from './Instructions/InstructionsList';

export default props => {
  const { technicians } = props;
  const dispatch = useDispatch();
  const [responseData, setResponse] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    // eslint-disable-next-line consistent-return
    (async () => {
      if (technicians) {
        const response = await asyncFetch(
          `${process.env.REACT_APP_TECHNICIANS_API}/DigitalsSignatures/check-technician-signature`,
          {
            method: 'POST',
            mode: 'cors',
            referrerPolicy: 'strict-origin-when-cross-origin',
            body: JSON.stringify({
              users: technicians
                ?.filter(x => x.userId)
                ?.map(x => ({
                  userId: x.userId,
                  userName: x.userName,
                  names: x.name,
                })),
            }),
          },
          {
            'Content-Type': 'application/json',
          },
          undefined,
          dispatch
        );

        if (response && response.isSuccess) {
          setResponse(response.users);
          dispatch(
            signedTechnicians({
              technicians: response.users,
              show: response.users.every(x => x.isSigned),
            })
          );
        }
        if (response && response.errorMessage) {
          dispatch(setSnackbar({ open: true, message: response.errorMessage }));
        }
      }
    })();
  }, [dispatch, technicians]);

  return (
    <>
      <Dialog open={open} fullScreen>
        <Box>
          <InstructionsList setOpen={setOpen} />
        </Box>
      </Dialog>
      {responseData.map(x => (
        <DigitalSignatureInput setOpen={setOpen} key={x.userId} technician={x} />
      ))}
    </>
  );
};
